// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__1-IiH","abort":"style_abort__1A_hp","submit":"style_submit__bCSwi"};